import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import UserAvatarImage from '../user-avatar-image';
import UserBadge from '../user-badge';
import UserName from '../user-name';
import styles from './avatar.scss';

const Avatar = ({
  type,
  user = {},
  isImageVisible,
  isNameVisible,
  isBadgeVisible,
}) => {
  const className = classNames(
    styles.container,
    'blog-text-color',
    'blog-link-hover-color',
    'avatar',
    'blog-post-text-color',
  );
  return (
    <div className={classNames(className)}>
      {isImageVisible && <UserAvatarImage type={type} user={user} />}
      {isNameVisible && user.name && (
        <UserName className={styles.name} name={user.name} />
      )}
      {isNameVisible && isBadgeVisible && <UserBadge user={user} />}
    </div>
  );
};

Avatar.propTypes = {
  user: PropTypes.object.isRequired,
  type: PropTypes.string,
  isImageVisible: PropTypes.bool,
  isNameVisible: PropTypes.bool,
  isBadgeVisible: PropTypes.bool,
};

Avatar.defaultProps = {
  isImageVisible: true,
  isNameVisible: true,
  isBadgeVisible: true,
  type: Avatar.DEFAULT,
};

export default Avatar;
